import { CommunityMembershipRole, CommunityMembershipStatus } from '../enums';
import { DomainError } from '../errors/domain-error';
import {
  assertCommunityFeedAccess,
  isCommunityModeratorRole,
  type CommunityMembershipContext,
} from './community-post.policy';
import {
  CommunityModeratorPermission,
  assertCommunityModeratorPermission,
} from './community-moderator-permissions.policy';

export function isCommunityOwnerRole(role: CommunityMembershipRole | string): boolean {
  return role === CommunityMembershipRole.OWNER;
}

export function authorizeCommunityMemberDirectoryAccess(
  membership: CommunityMembershipContext | null | undefined,
  accessType: string,
): asserts membership is CommunityMembershipContext {
  assertCommunityFeedAccess(membership, accessType);
}

export function authorizeCommunityMemberModeration(
  actor: CommunityMembershipContext,
  target: { role: CommunityMembershipRole | string; userId: string },
): void {
  if (!isCommunityModeratorRole(actor.role)) {
    throw new DomainError('Community moderator access required');
  }
  assertCommunityModeratorPermission(actor, CommunityModeratorPermission.MANAGE_MEMBERS);
  if (isCommunityOwnerRole(target.role)) {
    throw new DomainError('Cannot moderate the community owner');
  }
  if (
    target.role === CommunityMembershipRole.MODERATOR &&
    !isCommunityOwnerRole(actor.role)
  ) {
    throw new DomainError('Only the community owner can moderate other moderators');
  }
}

export function authorizeCommunityModeratorAssignment(actor: CommunityMembershipContext): void {
  if (!isCommunityOwnerRole(actor.role)) {
    throw new DomainError('Only the community owner can manage moderators');
  }
}

export function authorizeCommunitySelfMuteBlock(params: {
  actorUserId: string;
  targetUserId: string;
}): void {
  if (params.actorUserId === params.targetUserId) {
    throw new DomainError('Cannot mute or block yourself');
  }
}

export function isCommunityMembershipActive(status: CommunityMembershipStatus | string): boolean {
  return status === CommunityMembershipStatus.ACTIVE;
}
